import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'

/** External URL: in-app browser sheet on device, new tab on web (as v1). */
export const openExternalUrl = (url: string) => {
  if (Capacitor.isNativePlatform()) {
    void Browser.open({ url })
  } else {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
